import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const NAV = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Service Area',
  href: '#area'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Header({
  onOpenSchedule
}: {
  onOpenSchedule?: () => void;
}) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-md' : 'bg-white/80 backdrop-blur'}`} data-id="element-142" data-mp="3baxvntx6kcwr">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-143" data-mp="2wkunkxao3p7v">
        <a href="#top" className="flex items-center gap-3" aria-label={SITE.shortName} data-id="element-144" data-mp="2rlrijcuotizw">
          <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-12 w-auto sm:h-14" data-id="element-145" data-mp="2ro48odalmzo1" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-146" data-mp="2hnlk5583auzs">
          {NAV.map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-slate-700 transition-colors hover:text-nfblue" data-id="element-147" data-mp="3fbcb8ngn7umd">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-148" data-mp="35lj35wfplxmv">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-nfgreen-dark" data-id="element-149" data-mp="35jy7g3hns8nf">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-150" data-mp="30lo8riwq6px2" />
            Licensed & Insured
          </span>
          <button onClick={onOpenSchedule} className="inline-flex items-center gap-2 rounded-full bg-nfblue px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-transform hover:scale-[1.03] hover:bg-nfblue-dark" data-id="element-151" data-mp="1x7khws3u6mk">
            Schedule Visit
          </button>
        </div>

        <button className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-152" data-mp="1wbmk2u94137a">
          {open ? <XIcon className="h-6 w-6" data-id="element-153" data-mp="1mla31c0i7s5w" /> : <MenuIcon className="h-6 w-6" data-id="element-154" data-mp="1mki9e6qgw4i9" />}
        </button>
      </div>

      <AnimatePresence data-id="element-155" data-mp="18ls8eg0j1kom">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-slate-100 bg-white lg:hidden" data-id="element-156" data-mp="1cooxmpkkof1j">
            <nav className="flex flex-col px-4 py-4" aria-label="Mobile" data-id="element-157" data-mp="2t2f4u56znjfe">
              {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-base font-semibold text-slate-700 hover:bg-slate-50" data-id="element-158" data-mp="2y1rropxv0qhz">
                  {item.label}
                </a>)}
              <button onClick={() => {
            setOpen(false);
            onOpenSchedule?.();
          }} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-nfblue px-5 py-3 text-base font-bold text-white" data-id="element-159" data-mp="hgmm2i4upc9f">
                Schedule Visit
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}